/******/ (() => { // webpackBootstrap
(() => {
(function (n, v) {
    // eslint-disable-next-line max-len
    if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
      if (sessionStorage.getItem('oots_beacon')) return;

      navigator.sendBeacon('https://app.outofthesandbox.com/beacon', new URLSearchParams({
        shop_domain: window.Shopify.shop,
        shop_id: window.Store.id,
        theme_name: n,
        theme_version: v,
        theme_store_id: window.Shopify.theme.theme_store_id,
        theme_id: window.Shopify.theme.id,
        theme_role: window.Shopify.theme.role,
      }));

      sessionStorage.setItem('oots_beacon', '');
    }
  }('turbo','9.4.0'))
})();

(() => {
rimg.shopify.init('[data-rimg="lazy"]', {
  round: 1
});
const sections = new ShopifySectionsManager();
sections.register('age-gate', section => new AgeGate.PageAgeGate(section));
const ageGatePage = document.getElementById('age-gate-page');
if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}
document.addEventListener('DOMContentLoaded', function () {
  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;
  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener('load', () => {
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();
  window.header.init();
  window.mobileSearch.init();
  window.siteOverlay.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.predictiveSearch.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.logoList.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.shoppableImage.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();
  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const {
    pathname
  } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            window.header.unload();
            window.header.init();
          }
        }
        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }
            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? '4:3' : '16:9';
  }
  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');
  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const {
        target
      } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }
  $('body').on('change', '#tag_filter', () => {
    $('[data-option-filter] input').prop('checked', false);
    window.quickFilter.init();
  });
  $('body').on('change', '#blog_filter', function () {
    const url = $(this).val();
    window.location = url;
  });
  $('input, select, textarea').on('focus blur', event => {
    $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 1}`);
  });

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: $('.content').offset().top
    }, 500);
  });
  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });
  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });
  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });
  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });
  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }
  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });
  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });
  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }
  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({
      scrollTop: $('#new-comment').offset().top - 140
    }, 'slow');
  }
  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, {
      offset: '70%'
    });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, {
      offset: '70%'
    });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, {
      offset: '70%'
    });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, {
      offset: '70%'
    });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2
  });
  window.utils.createAccordion('.footer_menu', 'h6', 'ul');
  window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');
  window.utils.initializeTabs();
  window.accordion.init();
  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });
  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }
  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }
  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);
    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }
  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('.product-list');
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('.product-list');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      }
    });
  }
  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID
      },
      success(data) {
        
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }
          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      }
    });
  }
  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');
    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');
      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }
  
  function refreshCart(cart, cusCount = 0, checkFreeProducts = true) {
    // Free products disabled
    // if (checkFreeProducts && typeof window.checkFreeProducts === "function") {
      // window.checkToClearCart(cart);
    // }
    console.log('cart refresh fucntion called ');

    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;
    $cartForm.data('total-discount', cart.total_discount);
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');
      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;
      $.each(cart.items, (index, item) => {
        
        // const itemDiscounts = item.discounts;
        let item_discount_allocations = item.line_level_discount_allocations;
        let discountMessage = '';
        
        let discount_value = item_discount_allocations[0]?.discount_application.value.replace(/\.0$/, '') || '';
        let discount_type = item_discount_allocations[0]?.discount_application.value_type === 'percentage' || false;

        discount_type && ( discountMessage = `<p class="notification-discount badge meta">${discount_value}% OFF</p>`)

        // for (let i = 0; i < itemDiscounts.length; i++) { const { title } = itemDiscounts[i]; discountMessage = `<p class="notification-discount meta">${title}</p>`;}
                
        const lineID = index + 1;
        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">` + `<a href="${item.url}">`;
        
        let prd_preview_img = null;
        let item_imageUrl = null;

        if (item.properties) { $.each(item.properties, (title, value) => { if (value && value !== "on") {if (title === "DOWNLOAD PROOF" || title === "Product preview image") { prd_preview_img = value }}}) }

        if (item.image) {
            // cartItemsHTML += `${'<div class="cart_image">' + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />` + '</div></a>';
            item_imageUrl = item.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "");
        }

        if (prd_preview_img !== null && prd_preview_img !== "") { item_imageUrl = prd_preview_img; } 

        if (item_imageUrl !== null && item_imageUrl !== "") {
          // // Reproducing to next code to get the url of the img selected to be printed on the custom rug
          // let prevTag = "";
          // if(item_imageUrl == prd_preview_img) {
          //   if (item.properties) {
          //     let imgUrlExist = 0;
          //     $.each(item.properties, (title, value) => {
          //       if (value && value !== 'on') {
          //         const isHiddenProperty = title.substring(0, 2) === "__";
          //         if (!isHiddenProperty) {
          //           if (value.includes('https') && imgUrlExist == 0) {
          //             item_imageUrl = value;
          //           } else if (value.includes('https') && imgUrlExist == 1) {
          //             prevTag = `<a class="pplr_slide" href="${value}">PREVIEW</a>`
          //           }
          //           imgUrlExist++
          //         }
          //       }
          //     });
          //   }
          // }

          let encodedTitle = htmlEncode(item.title);
          cartItemsHTML += `<div class="cart_image"><img src="${item_imageUrl}" alt="${encodedTitle}" /></div></a>`;
    
          // cartItemsHTML += `<div class="cart_image"><img src="${item_imageUrl}" alt="${encodedTitle}" />${prevTag !== "" ? prevTag : ''}</div></a>`;
        }

        // console.log({props:item.properties,prd_preview_img, item_imageUrl});
        
        
        let item_size = item.options_with_values.find(i => i.name.includes('Size'))?.value || '';
        let item_shape = item.options_with_values.find(i => i.name.includes('Shape'))?.value || '';
        let item_title = `<span><strong>${ item.product_title}</strong></span> </br>`;
        if (item_size.length > 0 || item_shape.length > 0) {
          item_title += `<strong>Size:</strong> ${item_size} </br><strong>Shape:</strong> ${item_shape}`
        }

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a class="mini-cart__item-title__text" href="${item.url}">${item_title}</a>`;
        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }
        if (item.properties) {
          
          cartItemsHTML += '<div class="mini-cart__item-properties">';
          let imgUrlExist = 0;
          $.each(item.properties, (title, value) => {
            if (value && value !== 'on') {

              const isHiddenProperty = title.substring(0, 2) === "__";
              const isOriginalImage = title.includes('Original image');
              if (!isHiddenProperty || isOriginalImage) {
                if (value.includes('https') && imgUrlExist <= 1) {
                  cartItemsHTML += `<div class="mini-cart__item-property"><a class="pplr_slide" href="${value}">${(imgUrlExist < 1 || isOriginalImage) ? 'Original image' : 'Preview image'}</a></div>`;
                  imgUrlExist++;
                }
                else if (imgUrlExist <= 1){
                  cartItemsHTML += `<div class="mini-cart__item-property">${title}: ${value}</div>`;
                }
                else if (title.toLowerCase() === 'comments') {
                    cartItemsHTML += `<div class="mini-cart__item-property">${title}: ${value}</div>`;
                }
              }
            }
          });
          cartItemsHTML += '</div>';
        }
        cartItemsHTML += '</div><div class="mini-cart__item-price-quantity-container"><div class="mini-cart__item-price">';
        //   $.ajax({
        //     dataType: 'json',
        //     async: false,
        //     cache: false,
        //     url: `/products/${item.handle}.js`,
        //     success(data) {
        //       let productData = data;
        //       // If item has more than one variant, need to make sure we are pulling data from the correct variant
        //       if (productData.variants) {
        //         const itemVariants = productData.variants;
        //         if (itemVariants.length > 1) {
        //           for (let v = 0; v < itemVariants.length; v++) {
        //             if (itemVariants[v].id === item.id) {
        //               productData = itemVariants[v];
        //             }
        //           }
        //         }
        //       }

        //       // If compare at price exists then item is on sale CURRENTLY OFF
        //       if (productData.compare_at_price && productData.compare_at_price > productData.price && false) {
        //         productHasSale = true;
        //         productCompareAtPrice = productData.compare_at_price;
        //         productFinalPrice = productData.price;
                
        //       } else {
        //         // Check required for non-sale items
        //         productHasSale = false;
        //       }
        //     }
        //   });
          if (productHasSale === true) {
            // puts the slash through the old item price
            const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
            cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
            console.log("start item price",itemPrice);
            

            // Total savings
            saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
            totalSaving = saving + totalSaving;
          } else if (item.price > item.final_price) {
            // puts the slash through the old item price
            
            // const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))}</span> <span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;

            const itemPrice = `${window.Shopify.formatMoney(Math.ceil(item.final_price / 100) * 100, $('body').data('money-format')).replace(/\.00$/, '')}</span> <span class="money was_price">${window.Shopify.formatMoney(Math.ceil(item.price / 100) * 100, $('body').data('money-format')).replace(/\.00$/, '')}</span>`;

            cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
            // console.log("money sale 1",itemPrice);
            // console.log("productCompareAtPrice",productCompareAtPrice);
            // console.log("productFinalPrice",productFinalPrice);
            
          } else {
            const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format')).replace(/\.00$/, '');          
            console.log('Item Price', $('body').data('money-format'));
            
            if (item.price > 0) {
              cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
            } else {
              // cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
            }
          }
        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';
          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }
          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.price > item.final_price) { cartItemsHTML += discountMessage }
        
        cartItemsHTML += '<div class="product-quantity-box ctm">';
        if (item.price > 0) {
          cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
          cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`; 
          cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        }
        cartItemsHTML += '</div></div>';
        cartItemsHTML += `</div><a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart" ${!(item.price > 0) ? `style="display: none;"` : ""}><span class="remove-icon"><svg xmlns="http://www.w3.org/2000/svg" width="15px" height="20px" viewBox="0 0 448 512"><path d="M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"/></svg> </span></a>`;
      });
      const cartDiscounts = cart.cart_level_discount_applications;
      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const {
          title
        } = cartDiscounts[i];
        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }
      
      cartActionHTML += `<span class="right">`;
      if(cart.total_discount > 0){ cartActionHTML += `<span class="money was_price">${window.Shopify.formatMoney(cart.original_total_price, $('body').data('money-format')).replace(/\.00$/, '')}</span> ` }      
      cartActionHTML += `<span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span><span>${window.PXUTheme.translation.cart_subtotal_text.toUpperCase()}:</span>`;

      totalSaving += cart.total_discount;
      if ( totalSaving > 0) { //window.PXUTheme.theme_settings.display_savings &&
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format')).replace(/\.00$/, '')}</span></span>` + `<span>${window.PXUTheme.translation.cart_savings_text}:</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    const freeVariants = "51251607863617,51251475611969,51252103938369,51252413104449,51266493251905".split(",");
    let cartCountWithoutFreeGifts = 0;
    for (let item of cart.items) {
      if (!freeVariants.includes(String(item.variant_id))) {
        cartCountWithoutFreeGifts += item.quantity;
      }
    }

    $('.js-cart_items').attr('data-ctm-cart-count', cart.item_count);
    $('.js-cart_items').attr('data-ctm-cart-count-no-free', cartCountWithoutFreeGifts);
    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Mirror per-line price into the checkout button
    mirrorPplrPriceToButton();

  // Initialize any dynamic pplr slide anchors after the cart HTML is updated
  initPplrSlides();

    is_qty_greater_than_two_than_disc_text()
    // dis_apply_btn()

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  
  // if(cusCount < 10){
  //     let newC = cusCount+1;
  //     console.log(newC,'count');
  //     refreshCart(cart, newC);
  // }

  }
  // Make this function global to be called in other places to update the cart
  window.refreshCart = refreshCart;

  // Copies the first found .money.a_pplr_item_line_price content into the checkout button span
  function mirrorPplrPriceToButton() {
    try {
      const $buttonPrice = $('.mimic-praice');
      if (!$buttonPrice.length) return;

      // Primary source: cart subtotal .money that is not a was_price
      const $subtotalMoney = $('.js-cart_subtotal .money').not('.was_price').first();
      if ($subtotalMoney.length) {
        $buttonPrice.html($subtotalMoney.html());
        return;
      }

      // Fallback: any per-line pplr item line price
      const $source = $('.money.a_pplr_item_line_price').first();
      if ($source.length) {
        $buttonPrice.html($source.html());
      } else {
        $buttonPrice.html('');
      }
    } catch (e) {
      // silent
    }
  }

  // Observe changes to cart items and subtotal so button updates live when quantities change
  (function observeCartChanges() {
    const selectors = ['.js-cart_items', '.js-cart_subtotal'];
    const observer = new MutationObserver(mutations => {
      // Directly call mirror unconditionally on mutation to keep sync (cheap operation)
      mirrorPplrPriceToButton();
    });

    selectors.forEach(sel => {
      const el = document.querySelector(sel);
      if (el) {
        observer.observe(el, { childList: true, subtree: true, characterData: true });
      }
    });
    // As a safety fallback, also listen to input change events on quantity inputs to trigger update
    document.addEventListener('input', e => {
      if (e.target && e.target.classList && e.target.classList.contains('quantity')) {
        mirrorPplrPriceToButton();
      }
    }, { passive: true });
  })();

  // Initialize pplr preview anchors inside the mini cart so they have correct labels and behavior
  function initPplrSlides() {
    try {
      const anchors = document.querySelectorAll('.cart_content .mini-cart__item-properties .pplr_slide');
      anchors.forEach((anchor, index) => {
        // label first anchor 'Original image', subsequent anchors 'Preview image'
        anchor.textContent = index === 0 ? 'Original image' : (anchor.textContent.trim() || 'Preview image');
        // ensure links open in a new tab if they are external images
        if (anchor.getAttribute('href') && anchor.getAttribute('href').startsWith('http')) {
          anchor.setAttribute('target', '_blank');
          anchor.setAttribute('rel', 'noopener noreferrer');
        }
      });
    } catch (e) {
      // silent
    }
  }

// ======= cart refresh function ========
  let cartRefreshWork = true;

  document.addEventListener("click", function (evt) {
    if (evt.target.closest(".product-quantity-box") || evt.target.closest(".js-cart-remove-btn")) {
      cartRefreshWork = false;
    } else {
      cartRefreshWork = true; 
    }
  });

  const CTM_Cart_refresh = () => {  
    if (!cartRefreshWork) return;

    document.body?.classList.add('side_cart_active');
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      success(cart) {
        setTimeout(function () {
          refreshCart(cart);
          if ($('body').hasClass('fancybox-active')) {
            $.fancybox.close();
          }
          if ($('#header').is(':visible')) {
            $('#header .cart-container').addClass('active_link');
          } else if ($('.sticky_nav--stick').length) {
            $('.sticky_nav .cart-container').addClass('active_link');
          } else {
            $('.top-bar .cart-container').addClass('active_link');
          }

          // block scrolling on mobile
          if (window.PXUTheme.media_queries.medium.matches) {
            const $cartContainer = $(this).parent();
            if ($cartContainer.hasClass('active_link')) {
              $('body').addClass('blocked-scroll');
            } else {
              $('body').addClass('blocked-scroll');
            }

            // Scroll to the top of the page unless the header is fixed
            const header = document.getElementById('header');
            if (header.classList.contains('mobile_nav-fixed--false')) {
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        }, 300);
      }
    });          
  };

  const onload_Cart_refresh = () => {
    // console.log('onload_Cart_refresh');
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      cache: false,
      success(cart) {
        setTimeout(function () {
          refreshCart(cart);
          is_qty_greater_than_two_than_disc_text();
        }, 300);
      }
    });          
  };

  onload_Cart_refresh();
  
  const ctm_cart_count = document.querySelector("header[data-desktop-header-flag] .cart-container .cart_count");
  const topbarElemt = document.querySelector("header[data-desktop-header-flag] .top-bar");
  
  let cartCount = 0;
  let observer = null;

  if (ctm_cart_count) {
      cartCount = ctm_cart_count.innerText;

      function activateObserver() {
          observer = new MutationObserver(() => {
              if (ctm_cart_count.innerText != cartCount) {
                  cartCount = ctm_cart_count.innerText;
                  
                  CTM_Cart_refresh();
                  if (topbarElemt) {
                      const elementPosition = topbarElemt.getBoundingClientRect().top + window.scrollY;
                      window.scrollTo({
                          top: elementPosition,
                          behavior: 'smooth'
                      });
                  }
              }
          });

          const config = { childList: true, subtree: true };
          observer.observe(ctm_cart_count, config);
      }

      const initialCartCount = ctm_cart_count.innerText;
      const config = { childList: true, subtree: true };

      const initialObserver = new MutationObserver(() => {
          if (ctm_cart_count.innerText !== initialCartCount) {
              activateObserver();
              initialObserver.disconnect();
          }
      });

      initialObserver.observe(ctm_cart_count, config);
      
  } else {
      console.error("Element not found.");
  } 


  // document.addEventListener("DOMContentLoaded",function () {
  //   const miniCarts = document.querySelectorAll(".mini_cart");
  //   miniCarts.forEach(function(miniCart) { 
  //       miniCart.addEventListener("click", function(e) {
  //           e.preventDefault();
  //           console.log("click");
  //           CTM_Cart_refresh();
  //       });
  //   });
  // })
 
  function is_qty_greater_than_two_than_disc_text(){
    let cart_qty = document.querySelector('.cart_items.js-cart_items').getAttribute('data-ctm-cart-count-no-free');
    cart_qty = parseInt(cart_qty);
    let dis_atc_res_txt_apply_btn = document.querySelectorAll('.discount-atc');

    dis_atc_res_txt_apply_btn.forEach(i => {
      if(cart_qty == 0 || cart_qty == 1){ i.classList.remove('dis--active') }
      else if(cart_qty > 1){ i.classList.add('dis--active'); dis_apply_btn() }     
    })

  }
  function dis_apply_btn() {

    let cart_qty = document.querySelector('.cart_items.js-cart_items').getAttribute('data-ctm-cart-count-no-free');
    cart_qty = parseInt(cart_qty);
    let dis_atc_res_txt = document.querySelectorAll('.discount-atc----action-text');

    dis_atc_res_txt.forEach( i => {
      let span_div = i.querySelector('span');

      if(cart_qty <= 0){ 
        i.classList.add('dis--active')
        span_div.innerHTML = 2;
      }
      else if(cart_qty > 1){
        i.classList.remove('dis--active')
        // fetch('/discount/BUY2GET20'); //There are two codes AUTO & CODED
      }  
      else if(cart_qty > 0){
        i.classList.add('dis--active')
        span_div.innerHTML = 1;
      }   
    })
  }

  

  document.addEventListener('click', (e) => {
    let item = e.target;
    
    if(item.closest('.discount-atc--button')){ dis_apply_btn()}
    // if(item.closest('.mini-cart__item .js-change-quantity')){ dis_apply_btn() }

    is_qty_greater_than_two_than_disc_text();
  })
   

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });
  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    cartItem.$element.addClass('animated fadeOutLeft');
    updateCartItemQuantity(cartItem);
    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }
    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });
  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', async function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');
      this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');
      if (this.recipientForm) {
        this.recipientForm.classList.remove('recipient-form--has-errors');
      }

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
        return false;
      }

      const postData = $addToCartForm.serialize();

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: postData,
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success(response) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          // fetch updated cart
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }
                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }
              }, 500);
            },
            error() {
              // silent
            }
          });
        },
        error: XMLHttpRequest => {
          const response = (() => { try { return JSON.parse(XMLHttpRequest.responseText); } catch (e) { return null; } })();
          if (response && response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            // do not inject warning elements here; keep behavior silent and restore button state
          }
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        }
      });
      return false;
    });
  }

  
  window.productPage.productSwatches();
});
/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
    } else {
      $(this).addClass('hidden').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
    }
  });
};
window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
})();

/******/ })()
;

// change side cart property name
document.addEventListener("readystatechange", function() {
	if ("complete" == document.readyState) {
    document.querySelectorAll('.cart_content .mini-cart__item-properties')?.forEach(item => {
      item.querySelectorAll('.pplr_slide')?.forEach((anchor, index) => {
        if (index === 0) {
          anchor.innerText = 'Original image';
        }
      });
    });
  }
});